import { render, staticRenderFns } from "./upVillage.vue?vue&type=template&id=614c1641&scoped=true&"
import script from "./upVillage.vue?vue&type=script&lang=js&"
export * from "./upVillage.vue?vue&type=script&lang=js&"
import style0 from "./upVillage.vue?vue&type=style&index=0&id=614c1641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c1641",
  null
  
)

export default component.exports